import { render } from "./PartnerBooking.vue?vue&type=template&id=806efac2&scoped=true"
import script from "./PartnerBooking.vue?vue&type=script&lang=js"
export * from "./PartnerBooking.vue?vue&type=script&lang=js"

import "./PartnerBooking.vue?vue&type=style&index=0&id=806efac2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-806efac2"]])

export default __exports__